const fotositems = [
    {
        id: "1",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_1.jpg",
        height: 522,
        position: "50% 10%",
        bw: false
    },
    {
        id: "2",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_2.jpg",
        height: 611,
        position: "50% 10%",
        bw: false
    },
    {
        id: "3",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_3.jpg",
        height: 500,
        position: "50% 80%",
        bw: false
    },
    {
        id: "4",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_4.jpg",
        height: 795,
        position: "50% 10%",
        bw: false
    },
    {
        id: "5",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_5.jpg",
        height: 442,
        position: "50% 10%",
        bw: false
    },
    {
        id: "6",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_6.jpg",
        height: 689,
        position: "70% 10%",
        bw: false
    },
    {
        id: "7",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_7.jpg",
        height: 537,
        position: "50% 10%",
        bw: false
    },
    {
        id: "8",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_8.jpg",
        height: 348,
        position: "50% 10%",
        bw: false
    },
    {
        id: "9",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_9.jpg",
        height: 777,
        position: "50% 10%",
        bw: false
    },
    {
        id: "10",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_10.jpg",
        height: 700,
        position: "50% 50%",
        bw: false
    },
    {
        id: "11",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_11.jpg",
        height: 650,
        position: "50% 30%",
        bw: false
    },
    {
        id: "12",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_12.jpg",
        height: 721,
        position: "50% 10%",
        bw: false
    },
    {
        id: "13",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_13.jpg",
        height: 800,
        position: "50% 10%",
        bw: false
    },
    {
        id: "14",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_14.jpg",
        height: 456,
        position: "50% 10%",
        bw: false
    },
    {
        id: "15",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_15.jpg",
        height: 678,
        position: "50% 10%",
        bw: false
    },
    {
        id: "16",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_16.jpg",
        height: 750,
        position: "50% 10%",
        bw: false
    },
    {
        id: "17",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_17.jpg",
        height: 900,
        position: "50% 10%",
        bw: false
    },
    {
        id: "18",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_18.jpg",
        height: 660,
        position: "50% 10%",
        bw: false
    },
    {
        id: "19",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_19.jpg",
        height: 797,
        position: "50% 10%",
        bw: false
    },
    {
        id: "20",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_20.jpg",
        height: 489,
        position: "50% 10%",
        bw: false
    },
    {
        id: "21",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_21.jpg",
        height: 355,
        position: "50% 10%",
        bw: false
    },
    {
        id: "22",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_22.jpg",
        height: 400,
        position: "50% 60%",
        bw: false
    },
    {
        id: "23",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_23.jpg",
        height: 600,
        position: "50% 50%",
        bw: false
    },
    {
        id: "24",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_24.jpg",
        height: 596,
        position: "50% 10%",
        bw: false
    },
    {
        id: "25",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_25.jpg",
        height: 450,
        position: "50% 40%",
        bw: false
    },
    {
        id: "26",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_26.jpg",
        height: 600,
        position: "50% 10%",
        bw: false
    },
    {
        id: "27",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_27.jpg",
        height: 533,
        position: "50% 10%",
        bw: false
    },
    {
        id: "28",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_28.jpg",
        height: 399,
        position: "50% 10%",
        bw: false
    },
    {
        id: "29",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_29.jpg",
        height: 677,
        position: "50% 10%",
        bw: false
    },
    {
        id: "30",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_30.jpg",
        height: 445,
        position: "50% 10%",
        bw: false
    },
    {
        id: "31",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_31.jpg",
        height: 712,
        position: "50% 10%",
        bw: false
    },
    {
        id: "32",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_32.jpg",
        height: 358,
        position: "50% 10%",
        bw: false
    },
    {
        id: "33",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_33.jpg",
        height: 533,
        position: "50% 10%",
        bw: false
    },
    {
        id: "34",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_34.jpg",
        height: 680,
        position: "50% 75%",
        bw: false
    },
    {
        id: "35",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_35.jpg",
        height: 398,
        position: "50% 10%",
        bw: false
    },
    {
        id: "36",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_36.jpg",
        height: 742,
        position: "50% 10%",
        bw: false
    },
    {
        id: "37",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_37.jpg",
        height: 467,
        position: "50% 10%",
        bw: false
    },
    {
        id: "38",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_38.jpg",
        height: 700,
        position: "50% 10%",
        bw: false
    },
    {
        id: "39",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_39.jpg",
        height: 500,
        position: "50% 10%",
        bw: false
    },
    {
        id: "40",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_40.jpg",
        height: 799,
        position: "50% 10%",
        bw: false
    },
    {
        id: "41",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_41.jpg",
        height: 700,
        position: "50% 10%",
        bw: false
    },
    {
        id: "42",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_42.jpg",
        height: 615,
        position: "50% 10%",
        bw: false
    },
    {
        id: "43",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_43.jpg",
        height: 442,
        position: "50% 10%",
        bw: false
    },
    {
        id: "44",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_44.jpg",
        height: 781,
        position: "60% 10%",
        bw: false
    },
    {
        id: "45",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_45.jpg",
        height: 533,
        position: "50% 10%",
        bw: false
    },
    {
        id: "46",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_46.jpg",
        height: 800,
        position: "50% 10%",
        bw: false
    },
    {
        id: "47",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_47.jpg",
        height: 700,
        position: "50% 10%",
        bw: false
    },
    {
        id: "48",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_48.jpg",
        height: 348,
        position: "50% 10%",
        bw: false
    },
    {
        id: "49",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_49.jpg",
        height: 675,
        position: "50% 10%",
        bw: false
    },
    {
        id: "50",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_50.jpg",
        height: 491,
        position: "50% 10%",
        bw: false
    },
    {
        id: "51",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_51.jpg",
        height: 359,
        position: "50% 50%",
        bw: false
    },
    {
        id: "52",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_52.jpg",
        height: 765,
        position: "50% 10%",
        bw: false
    },
    {
        id: "53",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_53.jpg",
        height: 422,
        position: "50% 10%",
        bw: false
    },
    {
        id: "54",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_54.jpg",
        height: 680,
        position: "50% 10%",
        bw: false
    },
    {
        id: "55",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_55.jpg",
        height: 357,
        position: "50% 10%",
        bw: false
    },
    {
        id: "56",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_56.jpg",
        height: 792,
        position: "50% 10%",
        bw: false
    },
    {
        id: "57",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_57.jpg",
        height: 900,
        position: "50% 10%",
        bw: false
    },
    {
        id: "58",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_58.jpg",
        height: 534,
        position: "50% 10%",
        bw: false
    },
    {
        id: "59",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_59.jpg",
        height: 399,
        position: "50% 10%",
        bw: false
    },
    {
        id: "60",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_60.jpg",
        height: 750,
        position: "50% 10%",
        bw: false
    },
    {
        id: "61",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_61.jpg",
        height: 900,
        position: "50% 10%",
        bw: false
    },
    {
        id: "62",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_62.jpg",
        height: 633,
        position: "50% 10%",
        bw: false
    },
    {
        id: "63",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_63.jpg",
        height: 345,
        position: "50% 10%",
        bw: false
    },
    {
        id: "65",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_64.jpg",
        height: 788,
        position: "50% 10%",
        bw: false
    },
    {
        id: "66",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_65.jpg",
        height: 788,
        position: "50% 10%",
        bw: false
    },
    {
        id: "67",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_66.jpg",
        height: 788,
        position: "50% 10%",
        bw: false
    },
    {
        id: "68",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_67.jpg",
        height: 788,
        position: "50% 10%",
        bw: false
    },
    {
        id: "69",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_68.jpg",
        height: 788,
        position: "50% 10%",
        bw: false
    },
    {
        id: "70",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_69.jpg",
        height: 500,
        position: "50% 50%",
        bw: false
    },
    {
        id: "71",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_71.jpg",
        height: 400,
        position: "50% 10%",
        bw: false
    },
    {
        id: "72",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_72.jpg",
        height: 514,
        position: "50% 10%",
        bw: false
    },
    {
        id: "73",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_73.jpg",
        height: 782,
        position: "50% 10%",
        bw: false
    },
    {
        id: "74",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_74.jpg",
        height: 341,
        position: "50% 10%",
        bw: false
    },
    {
        id: "75",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_75.jpg",
        height: 692,
        position: "50% 10%",
        bw: false
    },
    {
        id: "76",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_76.jpg",
        height: 449,
        position: "50% 10%",
        bw: false
    },
    {
        id: "77",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_77.jpg",
        height: 739,
        position: "50% 10%",
        bw: false
    },
    {
        id: "78",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_78.jpg",
        height: 388,
        position: "50% 10%",
        bw: false
    },
    {
        id: "79",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_79.jpg",
        height: 548,
        position: "50% 10%",
        bw: false
    },
    {
        id: "80",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_80.jpg",
        height: 621,
        position: "50% 10%",
        bw: false
    },
    {
        id: "81",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_81.jpg",
        height: 356,
        position: "50% 10%",
        bw: false
    },
    {
        id: "82",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_82.jpg",
        height: 777,
        position: "50% 10%",
        bw: false
    },
    {
        id: "83",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_83.jpg",
        height: 405,
        position: "50% 10%",
        bw: false
    },
    {
        id: "84",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_84.jpg",
        height: 699,
        position: "50% 10%",
        bw: false
    },
    {
        id: "85",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_85.jpg",
        height: 478,
        position: "50% 10%",
        bw: false
    },
    {
        id: "86",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_86.jpg",
        height: 367,
        position: "50% 10%",
        bw: false
    },
    {
        id: "87",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_87.jpg",
        height: 744,
        position: "50% 10%",
        bw: false
    },
    {
        id: "88",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_88.jpg",
        height: 621,
        position: "50% 10%",
        bw: false
    },
    {
        id: "89",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_89.jpg",
        height: 479,
        position: "50% 10%",
        bw: false
    },
    {
        id: "90",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_90.jpg",
        height: 335,
        position: "50% 10%",
        bw: false
    },
    {
        id: "91",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_91.jpg",
        height: 795,
        position: "50% 10%",
        bw: false
    },
    {
        id: "92",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_92.jpg",
        height: 516,
        position: "50% 10%",
        bw: false
    },
    {
        id: "93",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_93.jpg",
        height: 700,
        position: "50% 70%",
        bw: false
    },
    {
        id: "94",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_94.jpg",
        height: 812,
        position: "50% 10%",
        bw: false
    },
    {
        id: "95",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_95.jpg",
        height: 347,
        position: "50% 10%",
        bw: false
    },
    {
        id: "96",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_96.jpg",
        height: 612,
        position: "50% 10%",
        bw: false
    },
    {
        id: "97",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_97.jpg",
        height: 778,
        position: "50% 10%",
        bw: false
    },
    {
        id: "98",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_98.jpg",
        height: 468,
        position: "50% 10%",
        bw: false
    },
    {
        id: "99",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_99.jpg",
        height: 592,
        position: "50% 10%",
        bw: false
    },
    {
        id: "100",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_100.jpg",
        height: 381,
        position: "50% 10%",
        bw: false
    },
    {
        id: "101",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_101.jpg",
        height: 653,
        position: "50% 10%",
        bw: false
    },
    {
        id: "102",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_102.jpg",
        height: 341,
        position: "50% 10%",
        bw: false
    },
    {
        id: "103",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_103.jpg",
        height: 721,
        position: "50% 10%",
        bw: false
    },
    {
        id: "104",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_104.jpg",
        height: 399,
        position: "50% 10%",
        bw: false
    },
    {
        id: "105",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_105.jpg",
        height: 788,
        position: "50% 10%",
        bw: false
    },
    {
        id: "106",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_106.jpg",
        height: 468,
        position: "50% 10%",
        bw: false
    },
    {
        id: "107",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_107.jpg",
        height: 622,
        position: "50% 10%",
        bw: false
    },
    {
        id: "108",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_108.jpg",
        height: 351,
        position: "50% 10%",
        bw: false
    },
    {
        id: "109",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_109.jpg",
        height: 743,
        position: "50% 10%",
        bw: false
    },
    {
        id: "110",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_110.jpg",
        height: 482,
        position: "50% 10%",
        bw: false
    },
    {
        id: "111",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_111.jpg",
        height: 400,
        position: "50% 10%",
        bw: false
    },
    {
        id: "112",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_112.jpg",
        height: 358,
        position: "50% 10%",
        bw: false
    },
    {
        id: "113",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_113.jpg",
        height: 657,
        position: "50% 10%",
        bw: false
    },
    {
        id: "114",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_114.jpg",
        height: 396,
        position: "50% 10%",
        bw: false
    },
    {
        id: "115",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_115.jpg",
        height: 701,
        position: "50% 10%",
        bw: false
    },
    {
        id: "116",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_116.jpg",
        height: 478,
        position: "50% 10%",
        bw: false
    },
    {
        id: "117",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_117.jpg",
        height: 800,
        position: "50% 10%",
        bw: false
    },
    {
        id: "118",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_118.jpg",
        height: 716,
        position: "50% 10%",
        bw: false
    },
    {
        id: "119",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_119.jpg",
        height: 543,
        position: "50% 10%",
        bw: false
    },
    {
        id: "120",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_120.jpg",
        height: 335,
        position: "50% 10%",
        bw: false
    },
    {
        id: "121",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_121.jpg",
        height: 783,
        position: "50% 10%",
        bw: false
    },
    {
        id: "122",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_122.jpg",
        height: 402,
        position: "50% 10%",
        bw: false
    },
    {
        id: "123",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_123.jpg",
        height: 450,
        position: "50% 10%",
        bw: false
    },
    {
        id: "124",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_124.jpg",
        height: 358,
        position: "50% 10%",
        bw: false
    },
    {
        id: "125",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_125.jpg",
        height: 774,
        position: "50% 10%",
        bw: false
    },
    {
        id: "126",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_126.jpg",
        height: 444,
        position: "50% 10%",
        bw: false
    },
    {
        id: "127",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_127.jpg",
        height: 550,
        position: "50% 10%",
        bw: false
    },
    {
        id: "128",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_128.jpg",
        height: 750,
        position: "50% 10%",
        bw: false
    },
    {
        id: "129",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_129.jpg",
        height: 623,
        position: "50% 10%",
        bw: false
    },
    {
        id: "131",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_131.jpg",
        height: 900,
        position: "50% 100%",
        bw: false
    },
    {
        id: "133",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_133.jpg",
        height: 692,
        position: "50% 10%",
        bw: false
    },
    {
        id: "135",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1763931416/foto_geral_135.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "136",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_136.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "137",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_137.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "138",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_138.jpg",
        height: 400,
        position: "50% 10%",
        bw: false
    },
    {
        id: "139",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_139.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "140",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_140.jpg",
        height: 250,
        position: "50% 10%",
        bw: false
    },
    {
        id: "141",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_141.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "142",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_142.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "143",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_143.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "144",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_144.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "145",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_145.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "146",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_146.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "147",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_147.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "148",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_148.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "149",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_149.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    },
    {
        id: "149",
        img: "https://res.cloudinary.com/davcmtvbd/image/upload/v1764626741/foto_geral_150.jpg",
        height: 811,
        position: "50% 10%",
        bw: false
    }
];


export default fotositems;
